export default __webpack_public_path__ + "static/media/Dashboard@2x.61beac94.jpg";